export default "<div class=\"container {{innerClass}}\" [attr.style]=\"getStyle() | cmsafe:'style'\">\r\n  <ng-content></ng-content>\r\n</div>"